import { createOrangeKitConnector } from "../connector";
import icon from "./icon";
import { OrangeKitWalletId } from "../types";
import { getWalletInjectedProvider } from "../utils";
import { OrangeKitBitcoinProvider } from "../bitcoin-wallet-provider";
export default function getOrangeKitXverseConnector({ rpcUrl, chainId, relayApiKey, relayConfig, }) {
    const injectedProvider = getWalletInjectedProvider(OrangeKitWalletId.XVERSE);
    const bitcoinWalletProvider = new OrangeKitBitcoinProvider(injectedProvider);
    return () => createOrangeKitConnector(OrangeKitWalletId.XVERSE, "Xverse", icon, rpcUrl, chainId, bitcoinWalletProvider, relayApiKey, relayConfig);
}
//# sourceMappingURL=connector.js.map